import React from 'react'

const Info = ({ isDarkMode}) => {
  const bodyClass = `about__info grid ${isDarkMode ? "dark-mode" : ""}`;

  return (
    <div className={bodyClass}>
        <div className="about__box">
        <i className="uil uil-award-alt"></i>
            <h3 className="about__title">Experience</h3>
            <span className="about__subtitle">1+ Years</span>
        </div>

        <div className="about__box">
         <i className="uil uil-briefcase-alt"></i>
            <h3 className="about__title">Completed</h3>
            <span className="about__subtitle">7+ Projects</span>
        </div>

        {/* <div className="about__box">
         <i className="uil uil-headphones-alt"></i>
            <h3 className="about__title">Support</h3>
            <span className="about__subtitle">Online 24/7</span>
        </div> */}

       
    </div>
  )
}

export default Info
